export const getScreenSize = (width) => {
  if (width < 375)
    return "xs"
  if (width < 650)
    return "sm"
  else if (width < 1000)
    return "md"
  else
    return "lg"
}